/**
 * My API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ReportCurrentPrevious } from './reportCurrentPrevious';


export interface ReportLiquidsProcessedAvgPerDay { 
    total_flow?: ReportCurrentPrevious;
    cream_flow?: ReportCurrentPrevious;
    skimmed_milk_flow?: ReportCurrentPrevious;
}

